

export default {
    FEEDBACK: '/feedback/:userId',

    FORM: 'form',
    ADMINLOGIN: '/adminLogin',

    UPLOAD_DOCUMENT: '/uploadDocuments/:type/:userId',

    E_NACH_PAGE: '/enach/:loanId',
    E_SIGN_PAGE: '/esign/:loanId',
    E_SIGN_NACH_PAGE: '/esignEnach/:loanId',

    Reference: '/userReference/:userId',

    E_NACH_PAGE_MOBILE: '/enachMobile/:loanId',
    E_SIGN_PAGE_MOBILE: '/esignMobile/:loanId',

    E_NACH_PAGE_CARD: '/enachCard/:userId',
    E_SIGN_PAGE_CARD: '/esignCard/:userId',
    // TeaGardenUrl

    KYC_FORM: '/kyc/:userId',
    KYC_FORM_SIGNZY: '/kycSignzy/:userId',
    KYC_MOBILE: '/kycMobile/:userId',
    FETCHMAIL: '/maillogin',
    MAIL_DATA: '/fetchmails',
    DIGILOCKER_KYC: '/digikyc/:userId',
    KFS_PAGE: '/kfs/:loanId',
    FI_VERIFICATION: '/FiVerififcation/:userId',
    ESIGN_REDIRECT_URL: '/setuEsign/getSignatureStatusAndDownload',

    DO_LETTER: '/DoLetter/:userId',
    VIDEO_KYC: '/vkyc/:userId',
    VIDEO_KYC_REDIRECT: '/vkycRedirect:',
    LOAN_CALCULATOR_SITE: '/loanCalculator',

    ENACH_WITH_ZIPNACH: '/enach/zipNach/:loanId',
        KYC_REDIRECT_URL: '/redirectKYCUser', //signzy 







};